import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Icon } from 'antd'
import classNames from "classnames/bind";
import { getSearchResult, getSuggest } from "../../actions/SearchAction";
import { getClientsByName } from "../../actions/ClientsAction";
import {
  setAdvancedSearchEnabled,
  setAdvancedSearchValuesFromNavBar
} from "../../actions/AppAction";
import {
  sendNotification
  // verifySpecialCharsInSearch
} from "../../utils/index";
import "./Searcher.css";

const SUGGEST_TYPE_ICONS = {
  folder: 'folder',
  image: 'picture',
  video: 'video-camera',
  document: 'file-text'
};

export class Searcher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: "",
      searchType: "all",
      wrapperColor: "#66c2e0",
      wrapperFilter: "",
      showSuggestions: false
    };
    this.suggestTimer = null;
  }

  componentDidMount() {
    const { newColor } = this.props;
    if (newColor) {
      this.setState({
        wrapperColor: newColor,
        wrapperFilter: "saturate(2)"
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { searchData, newColor } = this.props;
    // Fix (feedback QA/Ricardo): navegar a /home/result SOLO si aún no estamos ahí.
    // Antes se hacía history.push en CADA cambio de `searchData`; como cada tanda del
    // scroll infinito genera un array nuevo, se re-navegaba en cada página cargada →
    // ScrollToTop hacía window.scrollTo(0,0), perdiendo el foco/posición al desplegar
    // más resultados (y ensuciando el historial → rompía el botón "atrás").
    if (
      prevProps.searchData !== searchData &&
      searchData &&
      searchData.length > 0 &&
      this.props.location.pathname !== "/home/result"
    ) {
      this.props.history.push("/home/result");
    }
    if (prevProps.newColor !== newColor) {
      this.setState({
        wrapperColor: newColor,
        wrapperFilter: "saturate(2)"
      });
    }
  }

  handleSearchTypeChange = searchType => {
    const { searchText } = this.state;
    const { intl } = this.props;
    if (searchText.trim() === "" && searchType === "all") {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "item_search_field" }),
        1.7
      );
      return;
    }
    this.setState({ searchType }, () => {
      this.props.handleOnClickInputSearch();
      this.handleGoSearch();
    });
  };

  debouncedGetSuggest = (q) => {
    clearTimeout(this.suggestTimer);
    this.suggestTimer = setTimeout(() => {
      this.props.getSuggest(this.props.workclient, q);
    }, 200);
  };

  handleSearchTextChange = e => {
    const value = e.target.value.replace(/\\/g, "");
    this.setState({ searchText: value, showSuggestions: true });
    this.debouncedGetSuggest(value);
  };

  handleInputBlur = () => {
    setTimeout(() => {
      this.setState({ showSuggestions: false });
    }, 150);
    if (this.state.searchText === "") {
      this.props.handleHideSearchIcons();
    }
  };

  handleKeyPress = e => {
    const { searchText } = this.state;
    const { showSearchIcons } = this.props;

    const arrKeyNoAction = [
      "Shift",
      "Dead",
      "Control",
      "Alt",
      "Meta",
      "ContextMenu",
      "NumLock",
      "Insert",
      "Home",
      "PageUp",
      "Delete",
      "End",
      "PageDown",
      "Pause",
      "ScrollLock",
      "F1",
      "F2",
      "F3",
      "F4",
      "F5",
      "F6",
      "F7",
      "F8",
      "F9",
      "F10",
      "F11",
      "F12",
      "MediaPlayPause",
      "MediaStop",
      "MediaTrackPrevious",
      "MediaTrackNext",
      "AudioVolumeDown",
      "AudioVolumeUp",
      "AudioVolumeMute",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Backspace"
    ];

    if (arrKeyNoAction.includes(e.key)) {
      return;
    }

    if (e.key === "Enter") {
      // Enter dispara la búsqueda. preventDefault por si el input queda dentro de un
      // form/diálogo contenedor, para que Enter nunca provoque submit ni recarga.
      e.preventDefault();
      if (searchText.length === 0) return;
      this.setState(
        {
          searchType: "all",
          showSuggestions: false
        },
        () => {
          this.handleGoSearch();
          this.props.handleHideSearchIcons();
        }
      );
    } else if (e.key === "Escape" && showSearchIcons) {
      this.setState({ searchText: "" });
      this.props.handleShowSearchIcons();
    } else {
      if (searchText && searchText.length > 0 && !showSearchIcons) {
        this.props.handleShowSearchIcons();
      }

      if (searchText.length === 0) {
        this.props.handleHideSearchIcons();
      }
    }
  };

  handleGoSearch = () => {
    const { searchText, searchType } = this.state;

    this.props.setAdvancedSearchValuesFromNavBar({
      searchText,
      searchType
    });
    this.props.setAdvancedSearchEnabled(true);
    this.props.handleOnClickInputSearch();

    // if (workclient) {
    //   if (
    //     (searchText.trim().length > 1 &&
    //       this.props.searchText !== searchText) ||
    //     searchType !== this.props.searchType
    //   ) {
    //     if (searchText === "all" && searchType === "all") {
    //       this.props.getSearchResult(
    //         workclient,
    //         `"image" "folder" "video"`,
    //         searchType,
    //         1,
    //         null,
    //         null,
    //         40
    //       );
    //     } else if (searchText !== "all" && searchType === "all") {
    //       if (verifySpecialCharsInSearch(searchText)) {
    //         this.props.getSearchResult(
    //           workclient,
    //           encodeURIComponent(searchText.trim()),
    //           ``,
    //           1,
    //           null,
    //           null,
    //           40
    //         );
    //       } else {
    //         this.props.getSearchResult(
    //           workclient,
    //           searchText.trim(),
    //           ``,
    //           1,
    //           null,
    //           null,
    //           40
    //         );
    //       }
    //     } else {
    //       this.props.getSearchResult(
    //         workclient,
    //         searchText.trim(),
    //         searchType,
    //         1,
    //         null,
    //         null,
    //         40
    //       );
    //     }
    //     this.props.handleHideSearchIcons();
    //     this.setState({
    //       searchText
    //     });
    //   }
    // } else {
    //   this.props.handleHideSearchIcons();
    //   this.props.getClientsByName(1, searchText.trim());
    // }
  };

  handleOnBlur = () => {
    const { searchText } = this.state;
    if (searchText === "") {
      this.props.handleHideSearchIcons();
    }
  };

  setText = type => {
    const { searchText } = this.state;
    const { intl } = this.props;
    return searchText === "" ||
      searchText === intl.formatMessage({ id: "all" }).toLowerCase() ||
      searchText === intl.formatMessage({ id: "document" }).toLowerCase() ||
      searchText === intl.formatMessage({ id: "folder" }).toLowerCase() ||
      searchText ===
        intl.formatMessage({ id: "searche_tooltip_video" }).toLowerCase() ||
      searchText ===
        intl.formatMessage({ id: "searche_tooltip_image" }).toLowerCase()
      ? intl.formatMessage({ id: type })
      : searchText;
  };

  render() {
    //wrapperFilter
    const { searchText, searchType, wrapperColor, showSuggestions } = this.state;
    const { showSearchIcons, intl, showSearchNew, isClient, suggestions } = this.props;
    const classClickSearch = classNames(
      `${
        showSearchNew
          ? "tour-search-input nav-search"
          : "tour-search-input search"
      }`,
      {
        image: searchType === "image",
        video: searchType === "video",
        folder: searchType === "folder",
        all: searchType === "all"
      }
    );

    const classSearchResponsive = classNames(
      `${showSearchNew ? "nav-search-wrapper" : "search-wrapper"}`,
      {
        active: showSearchIcons
      }
    );

    return (
      <React.Fragment>
        <div className={classSearchResponsive}>
          <input
            type="text"
            value={searchText}
            autoComplete="off"
            onKeyDown={this.handleKeyPress}
            className={classClickSearch + " search-placeholder"}
            placeholder={
              isClient
                ? intl.formatMessage({ id: "searcher_placeholder_clients" })
                : intl.formatMessage({ id: "searcher_placeholder" })
            }
            onChange={this.handleSearchTextChange}
            style={{ border: "solid", borderColor: wrapperColor, fontSize: 12 }}
            onBlur={this.handleInputBlur}
          />

          {showSuggestions && suggestions && suggestions.length > 0 && (
            <div className="suggest-dropdown">
              {suggestions.map(item => (
                <div
                  key={item._id}
                  className="suggest-item"
                  onMouseDown={e => e.preventDefault()}
                  onClick={() => {
                    this.setState({ searchText: item.name, showSuggestions: false });
                    this.props.setAdvancedSearchValuesFromNavBar({ searchText: item.name, searchType: "all" });
                    this.props.setAdvancedSearchEnabled(true);
                    this.props.handleOnClickInputSearch();
                  }}
                >
                  <Icon type={SUGGEST_TYPE_ICONS[item.type] || 'file'} className="suggest-item-icon" />
                  <span>{item.name}</span>
                </div>
              ))}
            </div>
          )}

          {showSearchNew && <div className="nav-search-desktop-icon"></div>}

          {false && showSearchNew && showSearchIcons && (
            <div className="nav-search-dialog enabled">
              <div
                className="nav-search-dialog-item category"
                style={{ cursor: "pointer" }}
                onClick={() => this.handleSearchTypeChange("video")}
              >
                <span>
                  <svg
                    width={16}
                    height={13}
                    viewBox="0 0 16 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.0717 12.4044H1.92861C1.22271 12.4044 0.650391 11.8321 0.650391 11.1262V2.17861C0.650391 1.47271 1.22271 0.900391 1.92861 0.900391H14.0717C14.7776 0.900391 15.3499 1.47271 15.3499 2.17861V11.1262C15.3499 11.8321 14.7776 12.4044 14.0717 12.4044ZM4.1655 1.5395H1.92861C1.57582 1.5395 1.2895 1.82582 1.2895 2.17861V2.81772H4.1655V1.5395ZM7.68061 1.5395H4.80461V2.81772H7.68061V1.5395ZM11.1957 1.5395H8.31972V2.81772H11.1957V1.5395ZM14.7108 2.17861C14.7108 1.82582 14.4245 1.5395 14.0717 1.5395H11.8348V2.81772H14.7108V2.17861ZM14.7108 3.45683H1.2895V9.84794H14.7108V3.45683ZM14.7108 10.4871H11.8348V11.7653H11.1957V10.4871H8.31972V11.7653H7.68061V10.4871H4.80461V11.7653H4.1655V10.4871H1.2895V11.1262C1.2895 11.479 1.57582 11.7653 1.92861 11.7653H14.0717C14.4245 11.7653 14.7108 11.479 14.7108 11.1262V10.4871ZM7.23994 8.49462C7.18498 8.53904 7.11755 8.56972 7.0415 8.56972C6.86478 8.56972 6.72194 8.42688 6.72194 8.25016V5.05461C6.72194 4.87822 6.86478 4.73505 7.0415 4.73505C7.10956 4.73505 7.16932 4.76126 7.22141 4.79769L9.70467 6.35456C9.82802 6.39834 9.9175 6.5137 9.9175 6.65239C9.9175 6.75624 9.86477 6.84444 9.78808 6.9026L7.23994 8.49462Z"
                      fill="#526193"
                    />
                  </svg>
                </span>
                <p>{this.setText("searche_tooltip_video")}</p>
              </div>
              <div
                className="nav-search-dialog-item category"
                style={{ cursor: "pointer" }}
                onClick={() => this.handleSearchTypeChange("image")}
              >
                <span>
                  <svg
                    width={16}
                    height={12}
                    viewBox="0 0 16 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.0717 11.0836H1.92861C1.22271 11.0836 0.650391 10.5113 0.650391 9.80542V1.49697C0.650391 0.791074 1.22271 0.21875 1.92861 0.21875H14.0717C14.7776 0.21875 15.3499 0.791074 15.3499 1.49697V9.80542C15.3499 10.5113 14.7776 11.0836 14.0717 11.0836ZM14.7108 1.49697C14.7108 1.14418 14.4245 0.857861 14.0717 0.857861H1.92861C1.57582 0.857861 1.2895 1.14418 1.2895 1.49697V9.80542C1.2895 10.1582 1.57582 10.4445 1.92861 10.4445H14.0717C14.4245 10.4445 14.7108 10.1582 14.7108 9.80542V1.49697ZM13.5393 9.07523L11.5153 7.05117L10.3588 8.20764L11.4242 9.27304C11.546 9.39479 11.546 9.59227 11.4242 9.71434C11.3021 9.83609 11.1046 9.83609 10.9829 9.71434L6.40239 5.13383L2.46099 9.07523C2.33924 9.19698 2.14176 9.19698 2.01969 9.07523C1.89793 8.95316 1.89793 8.75567 2.01969 8.63392L6.14355 4.51006C6.15377 4.49472 6.16048 4.47779 6.17391 4.46404C6.23686 4.40109 6.31994 4.37233 6.40239 4.37425C6.48483 4.37233 6.56792 4.40109 6.63087 4.46404C6.64429 4.47779 6.65068 4.49472 6.66123 4.51006L9.9175 7.76633L11.2564 6.42739C11.267 6.41237 11.2734 6.39512 11.2868 6.38138C11.3497 6.31874 11.4328 6.28967 11.5153 6.29158C11.5977 6.28967 11.6808 6.31874 11.7438 6.38138C11.7572 6.39512 11.7636 6.41237 11.7741 6.42739L13.9806 8.63392C14.1024 8.75567 14.1024 8.95316 13.9806 9.07523C13.8586 9.19698 13.6611 9.19698 13.5393 9.07523ZM9.59794 4.05342C8.89204 4.05342 8.31972 3.48109 8.31972 2.77519C8.31972 2.0693 8.89204 1.49697 9.59794 1.49697C10.3038 1.49697 10.8762 2.0693 10.8762 2.77519C10.8762 3.48109 10.3038 4.05342 9.59794 4.05342ZM9.59794 2.13608C9.24515 2.13608 8.95883 2.4224 8.95883 2.77519C8.95883 3.12798 9.24515 3.4143 9.59794 3.4143C9.95073 3.4143 10.2371 3.12798 10.2371 2.77519C10.2371 2.4224 9.95073 2.13608 9.59794 2.13608Z"
                      fill="#526193"
                    />
                  </svg>
                </span>
                <p>{this.setText("searche_tooltip_image")}</p>
              </div>
              <div
                className="nav-search-dialog-item category"
                style={{ cursor: "pointer" }}
                onClick={() => this.handleSearchTypeChange("document")}
              >
                <span>
                  <svg
                    width={12}
                    height={16}
                    viewBox="0 0 12 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.155 15.0023H1.84658C1.14068 15.0023 0.568359 14.43 0.568359 13.7241V1.58096C0.568359 0.875058 1.14068 0.302734 1.84658 0.302734H7.90951C7.91015 0.302734 7.91111 0.302734 7.91174 0.302734H7.91814C8.02039 0.302734 8.10763 0.354183 8.16611 0.428959L11.307 3.56987C11.3821 3.62835 11.4332 3.71559 11.4332 3.81784V3.82455C11.4332 3.82519 11.4332 3.82551 11.4332 3.82615V13.7241C11.4332 14.43 10.8609 15.0023 10.155 15.0023ZM8.23769 1.38315V3.49829H10.3528L8.23769 1.38315ZM10.7941 4.1374H7.91814C7.74142 4.1374 7.59858 3.99424 7.59858 3.81784V0.941845H1.84658C1.49379 0.941845 1.20747 1.22817 1.20747 1.58096V13.7241C1.20747 14.0768 1.49379 14.3632 1.84658 14.3632H10.155C10.5078 14.3632 10.7941 14.0768 10.7941 13.7241V4.1374ZM8.8768 12.4458H3.1248C2.94809 12.4458 2.80525 12.303 2.80525 12.1263C2.80525 11.9499 2.94809 11.8067 3.1248 11.8067H8.8768C9.05352 11.8067 9.19636 11.9499 9.19636 12.1263C9.19636 12.303 9.05352 12.4458 8.8768 12.4458ZM8.8768 9.8894H3.1248C2.94809 9.8894 2.80525 9.74655 2.80525 9.56984C2.80525 9.39345 2.94809 9.25029 3.1248 9.25029H8.8768C9.05352 9.25029 9.19636 9.39345 9.19636 9.56984C9.19636 9.74655 9.05352 9.8894 8.8768 9.8894ZM8.8768 7.33295H3.1248C2.94809 7.33295 2.80525 7.19011 2.80525 7.0134C2.80525 6.837 2.94809 6.69384 3.1248 6.69384H8.8768C9.05352 6.69384 9.19636 6.837 9.19636 7.0134C9.19636 7.19011 9.05352 7.33295 8.8768 7.33295Z"
                      fill="#526193"
                    />
                  </svg>
                </span>
                <p>{this.setText("document")}</p>
              </div>

              <div
                className="nav-search-dialog-item category"
                style={{ cursor: "pointer" }}
                onClick={() => this.handleSearchTypeChange("folder")}
              >
                <span>
                  <svg
                    width="16"
                    height="14"
                    viewBox="0 0 16 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.4286 2.28571H8.808L6.68971 0.167429C6.58286 0.0600001 6.43714 0 6.28571 0H0.571429C0.256 0 0 0.256 0 0.571429C0 0.886857 0.256 1.14286 0.571429 1.14286H6.04914L8.16743 3.26114C8.27429 3.36857 8.42 3.42857 8.57143 3.42857H14.8571V12.5714H1.14286V2.85714C1.14286 2.54171 0.886857 2.28571 0.571429 2.28571C0.256 2.28571 0 2.54171 0 2.85714V13.1429C0 13.4589 0.256 13.7143 0.571429 13.7143H15.4286C15.7446 13.7143 16 13.4589 16 13.1429V2.85714C16 2.54171 15.7446 2.28571 15.4286 2.28571Z"
                      fill="#97A3CA"
                    />
                  </svg>
                </span>
                <p>{this.setText("folder")}</p>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchData: state.searcher.data,
    page: state.searcher.page,
    limit: state.searcher.limit,
    workclient: state.client.workclient,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    width: state.app.width,
    suggestions: state.searcher.suggestions
  };
};

const mapDispatchToProps = {
  getSearchResult,
  getClientsByName,
  setAdvancedSearchEnabled,
  setAdvancedSearchValuesFromNavBar,
  getSuggest
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Searcher))
);
